import { connect } from 'react-redux';
import { fetchAllCategoriesIfNeeded } from 'help/ducks/categories';
import { fetchAllFaqsIfNeeded} from 'help/ducks/faqs';
import HelpHome from 'help/components/home';
import { bindActionCreators } from 'redux';

HelpHome.need = [fetchAllCategoriesIfNeeded, fetchAllFaqsIfNeeded];

export function mapStateToProps({ help: { categories } }) {
  return {
    ...categories
  };
}

export function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    fetchAllCategoriesIfNeeded
  }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(HelpHome);



// WEBPACK FOOTER //
// ./help/containers/home.js